module.exports = __webpack_public_path__ + "static/img/connection_failed.5dd2531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/connections/connection_failed.png
// module id = rUbE
// module chunks = 31